import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../hooks/Contexts';
import Icon from '../common/Icon';
import dayjs from 'dayjs';

const FormGridItem = ({ form, handleFormCopy, handleFormMove, shown }) => {
  const user = useContext(UserContext);
  const navigate = useNavigate();
  const [controlsStyle, setControlsStyle] = useState({ opacity: '0' });
  const { id, active, name, submissions_count, global_quota, updated_at } =
    form;

  return (
    <div
      className={active ? 'item form active' : 'item form inactive'}
      onMouseEnter={(e) => {
        setControlsStyle({ opacity: '1' });
      }}
      onMouseLeave={(e) => {
        setControlsStyle({ opacity: '0' });
      }}
      style={{ opacity: shown ? '1' : '0', transition: 'opacity 0.5s ease' }}
    >
      <div
        className='item-link'
        onClick={() => navigate(`/manage/forms/${id}`)}
      >
        <div className='cargo'>
          <div className='name'>
            {form.is_parent && (
              <Icon icon='star fa-pull-left' title='Parent Form' />
            )}
            {form.submission_validate && (
              <Icon icon='link fa-pull-left' title='Child Form' />
            )}
            {name}
          </div>
          <div>
            <time
              dateTime={updated_at}
              className='meta-badge'
              title='Last Updated'
            >
              {dayjs(updated_at).format('M/DD/YYYY')}
            </time>
          </div>
          <div className='count' title='Submissions Count'>
            {submissions_count}
            {global_quota ? '/' + global_quota : ''}{' '}
            <i className='fa-solid fa-inbox' />
          </div>
        </div>
        {user.isAdmin && (
          <div
            className='controls'
            style={{ ...controlsStyle, transition: 'opacity 0.5s ease' }}
          >
            {submissions_count == 0 && (
              <Icon
                className='move'
                onClick={(e) => {
                  e.stopPropagation();
                  handleFormMove(form);
                }}
                icon='arrows'
                title='Move Form'
              />
            )}
            <Icon
              onClick={(e) => {
                e.stopPropagation();
                handleFormCopy(form);
              }}
              className='duplicate'
              icon='copy'
              faPrefix={'regular'}
              title='Copy Form'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FormGridItem;
